export function copyToClipboard(value: string): boolean {
  const inputField = document.createElement('input');
  inputField.setAttribute('type', 'text');
  inputField.setAttribute('value', value);
  document.body.appendChild(inputField);

  /**
   * Attempt to copy via the browser.
   */
  let copiedSuccessful = false;
  try {
      inputField.focus();
      inputField.select();
      copiedSuccessful = document.execCommand('copy');
  } catch (error) {
      // Error handled below.
  }

  /* tslint:disable:no-string-literal */
  if (!copiedSuccessful && window.navigator && window.navigator['clipboard']) {
      try {
          window.navigator['clipboard'].writeText(inputField.value);
          copiedSuccessful = true;
      } catch (err) {
          // Error handled below.
      }
  }

  document.body.removeChild(inputField);

  return copiedSuccessful;
}